export default "__VITE_ASSET__ed1fa2f8__"